<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="active-wrap container">
      <titleConfig
        :title="langSet == 'cn' ? '现场活动' : 'Onsite Events'"
        :type="2"
      ></titleConfig>
      <div class="list flex flex_wrap">
        <el-image v-for="item in list" :key="item.id" class="img" :src="langSet == 'cn' ? item.thumb : item.en_thumb" :fit="'cover'" @click="toList(item)"></el-image>
      </div>
      <nodata v-if="list.length == 0"></nodata>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import nodata from "@/components/nodata.vue";
import { categroyLists } from "@/api/api";

export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    nodata
  },
  data() {
    return {
      langSet: "",
      metaData: {},
      list: []
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    //25.9.17 活动分类列表 dxm
    this.getCategroyLists();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getCategroyLists() {
      const res = await categroyLists();
      this.list = res.data.lists;
    },
    toList(item) {
      this.$router.push({
        path: "/activeList",
        query: {
          id: item.id,
          title: this.langSet == 'cn' ? item.title : item.en_title,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.active-wrap {
  padding-top: 80px;
  min-height: 500px;
  .list {
    margin-top: 30px;
    .img {
      width: 298px;
      height: 169px;
      cursor: pointer;
      border-radius: 20px;
      margin: 0 29px 20px 0;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .active-wrap{
    padding-top: 0.58rem;
    .list .img{
      width: 100%;
      height: 3.81rem;
      margin: 0 0 0.58rem 0;
    }
  }
}
</style>